import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { PATH } from '../../../constants/path';
import { accountRoutes } from '../../../routes/account';

import modalService from '../../../services/modal';
import { logoutUser } from '../../../services/authentication/logout/actions';

import { mapRoutes } from '../../../utils/routeUtils';
import { isTokenExpired } from '../../../services/authentication/utils';

import Breadcrumb from '../../breadcrumb/Breadcrumb';
import AccountNavComponent from './AccountNavComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import './AccountPage.scss';

class AccountPage extends React.Component {
    componentWillMount() {
        this.checkAuthentication(this.props);

        if (this.props.location.pathname === PATH.ACCOUNT_PATH) {
            this.props.history.push(PATH.ACCOUNT_JACKPOT_PATH);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.checkAuthentication(nextProps);

            if (this.props.location.pathname === PATH.ACCOUNT_PATH) {
                this.props.history.push(PATH.ACCOUNT_JACKPOT_PATH);
            }
        }
    }

    isMemberAuthenticated = () => !isTokenExpired(this.props.token) && this.props.isAuthenticated;

    checkAuthentication({ history, showModal, logout }) {
        if (!this.isMemberAuthenticated()) {
            new Promise((resolve, reject) => {
                history.push('/');
                resolve();
            }).then(() =>
                logout(() =>
                    showModal(modalService.constants.MODAL_TYPE_LOGGED_OUT, {
                        id: 'logged-out-modal',
                        hideCloseButton: true
                    })
                )
            );
        }
    }

    getBreadcrumbRoutes() {
        const { location } = this.props;

        if (location.pathname === PATH.ACCOUNT_JACKPOT_PATH)
            return {
                label: this.props.i18nCashback.BREADCRUMB,
                route: PATH.ACCOUNT_JACKPOT_PATH
            };
        else if (location.pathname === PATH.ACCOUNT_EBONS_PATH)
            return {
                label: this.props.i18nEbon.BREADCRUMB,
                route: PATH.ACCOUNT_EBONS_PATH
            };
        else if (location.pathname === PATH.ACCOUNT_PROFILE_PATH)
            return {
                label: this.props.i18nProfile.BREADCRUMB,
                route: PATH.ACCOUNT_PROFILE_PATH
            };
        else if (location.pathname.startsWith(PATH.ACCOUNT_MESSAGES_PATH))
            return {
                label: this.props.i18nMessages.BREADCRUMB,
                route: PATH.ACCOUNT_MESSAGES_PATH
            };
        else if (location.pathname.startsWith(PATH.ACCOUNT_PAYMENTS_PATH))
            return {
                label: this.props.i18nPayments.BREADCRUMB,
                route: PATH.ACCOUNT_PAYMENTS_PATH
            };
        else {
            return {};
        }
    }

    render() {
        if (this.isMemberAuthenticated()) {
            return (
                <main role="main" className="conteneur conteneur-mobile" id="p-compte">
                    <Breadcrumb
                        defaultRoute
                        routes={[
                            {
                                label: this.props.BREADCRUMB,
                                route: PATH.ACCOUNT_PATH
                            },
                            this.getBreadcrumbRoutes()
                        ]}
                    />
                    <h1>{this.props.TITLE}</h1>
                    <AccountNavComponent />
                    <div className="account-content">{mapRoutes(accountRoutes)}</div>
                </main>
            );
        }
        return null;
    }
}

AccountPage.propTypes = {
    token: PropTypes.string,
    isAuthenticated: PropTypes.bool.isRequired
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        token: state.authentication.token,
        isAuthenticated: state.authentication.isAuthenticated,
        BREADCRUMB: state.i18n.page.ACCOUNT.BREADCRUMB,
        TITLE: state.i18n.page.ACCOUNT.TITLE,
        i18nCashback: state.i18n.page.ACCOUNT.CASHBACK,
        i18nPayments: state.i18n.page.ACCOUNT.PAYMENTS,
        i18nEbon: state.i18n.page.ACCOUNT.EBONS,
        i18nProfile: state.i18n.page.ACCOUNT.PROFILE,
        i18nMessages: state.i18n.page.ACCOUNT.MESSAGES
    };
};
const mapDispatchToProps = {
    showModal: modalService.actions.showModal,
    logout: logoutUser
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(AccountPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/account/AccountPage.js